/**
 * Red asterisk placed after a label to mark a mandatory field. Decorative only
 * — keep `required` on the control itself so assistive tech announces it.
 */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="ml-0.5 text-accentError">
      *
    </span>
  );
}
